// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__1QmgM","formSpace":"styles_formSpace__1Or_n"};